import { SkeletonLoader } from '@toggle/design-system';
import styled from 'styled-components';

export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;

export const DescriptionLoader = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '100%',
        height: '12px',
        borderRadius: '8px',
      },
    },
  ],
})`
  min-width: 600px;
`;

export const RankLoader = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '100%',
        height: '24px',
        borderRadius: '8px',
      },
    },
  ],
})`
  width: 50px;
`;

export const LogoLoader = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '100%',
        height: '32px',
        borderRadius: '40px',
      },
    },
  ],
})`
  width: 32px;
`;

export const ThemeNameLoader = styled(SkeletonLoader).attrs(() => ({
  areas: [
    {
      styles: {
        width: '100%',
        height: '24px',
        borderRadius: '8px',
      },
    },
  ],
}))<{ $width: string }>`
  width: ${({ $width }) => $width};
`;
